import { useState } from "react";
import { useSearchParamsToObject } from "./useSearchParamsToObject";
import { useUpdateSearchParam } from "./useUpdateSearchParam";

export function useFilter<T>(initialValue: any) {
  const params = useSearchParamsToObject();
  const state = useState(() => {
    return { ...initialValue, ...params } as T;
  });
  useUpdateSearchParam(state[0]);
  return state;
}
